import * as Yup from "yup";
import { CONSENT_VALIDATION_TEXT } from "@/pages/app/provider/consent-forms/ccm-consent/ccm-consent-copy-constant";
import { consentAcknowledgementSchema } from "@/pages/app/provider/consent-forms/ccm-consent/ccm-consent-schema";
import {
  PATIENT_CONSENT_TEXT,
  PATIENT_FIELDS,
} from "./patient-consent-constant";

export const patientConsentSchema = Yup.object({
  patient: Yup.object({
    patientName: Yup.string().trim().required().label(PATIENT_FIELDS[0].label),
    dateOfBirth: Yup.string()
      .nullable()
      .required()
      .label(PATIENT_FIELDS[2].label),
  }),
  releaseAuthorization: Yup.object({
    expiry: Yup.string().required(CONSENT_VALIDATION_TEXT.EXPIRY_REQUIRED),
    email: Yup.string().email(PATIENT_CONSENT_TEXT.EMAIL_ERROR),
  }),
  signature: Yup.object({
    patientSignature: Yup.string().when("unableToSignReason", {
      is: (reason?: string) => !reason?.trim(),
      then: (schema) =>
        schema.required(CONSENT_VALIDATION_TEXT.SIGNATURE_REQUIRED),
    }),
    responsiblePersonSignature: Yup.string().when("unableToSignReason", {
      is: (reason?: string) => !!reason?.trim(),
      then: (schema) =>
        schema.required(CONSENT_VALIDATION_TEXT.SIGNATURE_REQUIRED),
    }),
    signatoryName: Yup.string().when("unableToSignReason", {
      is: (reason?: string) => !!reason?.trim(),
      then: (schema) =>
        schema.trim().required(CONSENT_VALIDATION_TEXT.SIGNATORY_NAME_REQUIRED),
    }),
    relationshipToPatient: Yup.string().when("unableToSignReason", {
      is: (reason?: string) => !!reason?.trim(),
      then: (schema) =>
        schema.trim().required(CONSENT_VALIDATION_TEXT.RELATIONSHIP_REQUIRED),
    }),
  }),
  acknowledgement: consentAcknowledgementSchema,
});
